"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.heightLightTabIndex = exports.replaceUrl = exports.getPxByRem = void 0;
var url_1 = require("utils/url");
exports.getPxByRem = function (rem) {
    if (/(iPhone\sOS)\s([\d_]+)/.test(navigator.userAgent)) {
        return ((document.documentElement.clientWidth * 16) / 375) * rem;
    }
    else {
        return ((window.innerWidth * 16) / 375) * rem;
    }
};
exports.replaceUrl = function (floor, tagName) {
    var href = location.href, search = location.search;
    var subStr = search.indexOf("?") > -1 ? "&" : "?";
    var nameValue = encodeURIComponent(floor + "_" + tagName);
    var newUrl = href;
    if (search.indexOf("tag") > -1) {
        newUrl = url_1.replaceUrlParamVal("tag", nameValue);
    }
    else {
        newUrl = "" + href + subStr + "tag=" + nameValue;
    }
    window.history.replaceState({}, "", newUrl);
};
exports.heightLightTabIndex = function (tabs) {
    var tagValue = url_1.getSearchParamValue("tag") || "";
    if (!tagValue) {
        return 0;
    }
    var tagArr = tagValue.split("_");
    var tabName = tagArr[tagArr.length - 1];
    return tabs.findIndex(function (ele) { return ele.name === tabName; });
};
